import React from 'react';

import logoImg from './logo-1504.gif';
import styles from './navOld.scss';

const logo = () => (
  <a href="https://www.nies.go.jp/" target="_blank" rel="noopener noreferrer">
    <img className={styles.logo} src={logoImg}></img>
  </a>
);

export default function nav(user, logoutUrl, {lang=null, setLang=(() => undefined), topPage=false}={}) {
  const handleClick = (lang) => {
    if (window.history.replaceState) {
      const url = (() => {
        if (lang === 'ja') {
          return `?lang=${lang}`;
        } else {
          return window.location.pathname + window.location.search.replace(/[\?&]lang=[^&]+/, '').replace(/^&/, '?');
        }
      })();

      window.history.replaceState(null, '', url);
    }

    setLang(lang === 'ja' ? lang : null);
  };

  const LangSetter = ({globalLang, lang}) => {
    globalLang = globalLang || 'en';

    const props = {
      className: styles.nolink,
    };
    if (globalLang !== lang) {
      Object.assign(props, {
        className: styles.link,
        onClick: () => handleClick(lang),
      });
    }

    return (
      <span {...props}>{lang}</span>
    );
  };

  return (
    <nav className={styles.nav}>
      <div className={styles.left}>A-PLAT Pro</div>
      <div className={styles.right}>
        {topPage && logo()}
        <div>
          <LangSetter globalLang={lang} lang={'en'} /> / <LangSetter globalLang={lang} lang={'ja'} />
        </div>
        <div className={styles.user}>{user}</div>
        <a className={styles.logout} href={logoutUrl}>log out</a>
      </div>
    </nav>
  );
}
